// Redefiniing colors here because the goofy way scss is built for this projects doesn't
// let us easily directly import scss

export const colors = {
    green: '#047A6E',
    purple: '#742e8c',
    blue: '#1D48C0',
    lightBlue: '#50C4D9',
    darkBlue: '#0A1950',
    cpsgreen: '#00463F',
    orange: '#CF4016'
}

export const theme = {
    cpsEsColor: colors.purple,
    cpsHsColor: colors.darkBlue,
    prekCpsColor: colors.blue,
    prekCelColor: colors.lightBlue,
    progColor: colors.orange,
    availability: {
        available: 'green',
        limited: '#d7bb46',
        waitlist: 'red'
    }
}